import { AvailableTicketInfo, Event } from '@graphql/__generated/graphql'

const formatError = (ident: string, err: unknown) =>
  console.error(`[${ident ?? 'EventUtil'}]: ${err}`)

export const getAvailableTickets = (event: Partial<Event>) => {
  const payload: AvailableTicketInfo[] = []
  return event?.availableTickets?.tickets ?? []
  try {
    event?.availableTickets?.tickets?.forEach((t) => {
      if (t && t.remaining && parseInt(t.remaining) > 0) payload.push(t)
    })
  } catch (err) {
    formatError('GetAvailableTickets', err)
  }
  return payload
}
